import { render, staticRenderFns } from "./TableBrand.vue?vue&type=template&id=78ae0851&"
import script from "./TableBrand.vue?vue&type=script&lang=js&"
export * from "./TableBrand.vue?vue&type=script&lang=js&"
import style0 from "./TableBrand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports